import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { StyledEngineProvider } from "@mui/system";

import { PackableThemeProvider } from "packable-components";
import { PackableAppContextProvider } from "packable-components";

import "./index.css";
import "packable-common/dist/index.css";

import { filterTemplateList } from "./component/datafilter/DataFilter";
import { quickFilterTemplateList } from "./component/datafilter/DataFilter";
import { PackableStorageClientContextProvider } from "./component/context/PackableContextProvider";
import { config } from "./config";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <PackableThemeProvider
      appColorName="Packable Green"
    >
      <StyledEngineProvider injectFirst>
        <PackableAppContextProvider
          serviceBaseURL={config.API_URL}
          dataFilterTemplateList={filterTemplateList}
          dataQuickFilterTemplates={quickFilterTemplateList}
        >
          <PackableStorageClientContextProvider>
            <App />
          </PackableStorageClientContextProvider>
        </PackableAppContextProvider>
      </StyledEngineProvider>
    </PackableThemeProvider>
  </React.StrictMode>
);

serviceWorker.register();
